// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// components
import { Carousel } from "antd";
import Item from "../Item";

// dake data
const reviews = [1, 2];

const ReviewListModal = ({ list, closeModal }) => {
  return (
    <div className={styles.modal} onClick={closeModal}>
      <div onClick={(e) => e.stopPropagation()} className={styles.inner}>
        <p className={styles.heading}>Reviews and Ratings</p>
        <Carousel effect="fade" dots={false} arrows={true}>
          {list.map((item, index) => (
            <Item key={index} data={item} />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default ReviewListModal;
